/**
 * How big the whole app's text is on this phone: standard (already large: 18px body text), larger or
 * largest. Everything sized in rem grows with it — text, buttons and fields together.
 */
export type TextSize = "normal" | "large" | "xlarge";
const KEY = "nutricart.textSize";

export function getTextSize(): TextSize {
  try {
    const v = localStorage.getItem(KEY);
    if (v === "large" || v === "xlarge") return v;
  } catch {}
  return "normal";
}

export function setTextSize(s: TextSize) {
  try {
    if (s === "normal") localStorage.removeItem(KEY);
    else localStorage.setItem(KEY, s);
  } catch {}
  applyStoredTextSize();
}

export function applyStoredTextSize() {
  const s = getTextSize();
  if (s === "normal") document.documentElement.removeAttribute("data-text");
  else document.documentElement.setAttribute("data-text", s);
}
